module.exports = __webpack_public_path__ + "img/gallery-events.f630d468.png";